import { render, staticRenderFns } from "./ProductSelectionPopup.vue?vue&type=template&id=635c57cf&scoped=true"
import script from "./ProductSelectionPopup.vue?vue&type=script&lang=js"
export * from "./ProductSelectionPopup.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectionPopup.vue?vue&type=style&index=0&id=635c57cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c57cf",
  null
  
)

export default component.exports